import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Cell, PieChart, Pie, ResponsiveContainer } from 'recharts';
import { useTheme } from 'styled-components';
import ChartLabels from './ChartLabels/ChartLabels';
import KPIIndicator from './KPIndicator/KPIIndicator';
import KPITarget from './KPITarget/KPITarget';
import PieLabel from './PieLabel/PieLabel';

interface IKPIMeter {
  target?: number;
  value: number;
  metaText?: {
    value: string;
    position?: number;
    mode: 'weak' | 'normal' | 'strong';
  };
}
const KPIMeter: FC<IKPIMeter> = ({ target, value }) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const data = [
    { name: `${t('report.kpi.chartLabels.weak')}`, value: 30 },
    { name: `${t('report.kpi.chartLabels.normal')}`, value: 40 },
    { name: `${t('report.kpi.chartLabels.strong')}`, value: 30 },
  ];
  const [indicator, setIndicator] = useState(0);

  const COLORS = [
    theme.colors.accent.red[100],
    theme.colors.accent.blue[100],
    theme.colors.accent.green[100],
  ];

  useEffect(() => {
    let timeoutId: number;

    timeoutId = window.setTimeout(() => {
      setIndicator(value);
    }, 200);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [value]);

  return (
    <ResponsiveContainer width="100%" height={184}>
      <PieChart>
        <Pie
          cornerRadius={5}
          cy={144}
          dataKey="value"
          endAngle={0}
          innerRadius={76}
          label={props => <PieLabel {...props} />}
          labelLine={false}
          outerRadius={108}
          paddingAngle={2}
          rootTabIndex={-1}
          startAngle={180}
          isAnimationActive={false}
          {...{ data }}
        >
          {data.map(({ name }, index: number) => (
            <Cell
              key={`cell-${name}`}
              fill={COLORS[index % COLORS.length]}
              stroke={COLORS[index % COLORS.length]}
            />
          ))}
        </Pie>
        {KPIIndicator({ indicator, value })}
        {typeof target === 'number' ? KPITarget({ target }) : null}
        {ChartLabels({ labels: ['0', '100'] })}
      </PieChart>
    </ResponsiveContainer>
  );
};
export default KPIMeter;
